<template>
    <v-dialog v-model="modal" :scrim="false" width="900">
        <v-card>
            <component :is="component" :product="entry">
                <template v-slot:price="{offer}">
                    <tour-offer-delta-button
                        :offer="offer"
                        :offer-key="offerKey"
                        :entry-name="entry.entryName"
                        class="my-2"
                    />
                </template>
            </component>
        </v-card>
        <insurance-info-modal />
    </v-dialog>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {EventBus, SHOW_TOUR_INSURANCE_INFO} from '@/utils/event-bus'
    import TourOfferDeltaButton from '@/components/tours/search/TourOfferDeltaButton.vue'
    import InsuranceInfoModal from '@/components/insurance/info/InsuranceInfoModal.vue'
    import InsuranceOfferCard from '@/components/insurance/search/offers/InsuranceOfferCard.vue'
    import InsuranceOfferCardMobile from '@/components/insurance/search/offers/InsuranceOfferCardMobile.vue'

    @Component({
        components: {
            TourOfferDeltaButton,
            InsuranceInfoModal,
            InsuranceOfferCard,
            InsuranceOfferCardMobile,
        },
    })
    export class TourInsuranceInfoModal extends Vue {
        @Prop({required: true}) searchRequest

        modal = false
        entry = {}
        offerKey = null

        mounted() {
            EventBus.$on(SHOW_TOUR_INSURANCE_INFO, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_TOUR_INSURANCE_INFO, this.showModal)
        }

        async showModal({entry, offerKey}) {
            this.entry = entry
            this.offerKey = offerKey
            this.modal = true
        }

        get component() {
            return !this.$breakpoint.smAndDown
                ? resolveComponent('InsuranceOfferCard')
                : resolveComponent('InsuranceOfferCardMobile')
        }
    }

    export default TourInsuranceInfoModal
</script>
